/* eslint-disable no-unused-vars */
'use client';

import { questions } from '@/constants';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import ContactForm from '../forms/ContactForm';
import Button from '../ui/Button';
import AccordionsBlock from './AccordionsBlock';
import Section from './Section';

enum Mode {
    Faq = 'faq',
    Form = 'form',
}

const SECTION_ID = 'questions';

export default function QuestionsSection() {
    const t = useTranslations();
    const [mode, setMode] = useState<Mode>(Mode.Faq);
    const router = useRouter();

    return (
        <Section
            id={SECTION_ID}
            title={t('Header.questions')}
            className="bg-bg-200 relative max-2xl:min-h-0 lg:py-0"
        >
            <div className="max-xl:mx-5 flex justify-between max-lg:flex-col lg:mt-44 max-xl:gap-24 max-lg:gap-12 xl:gap-24 lg:pl-4">
                <div className="flex lg:flex-col top-44 lg:sticky lg:h-full lg:pb-32 lg:min-w-[370px]">
                    <Button
                        className="[&>div]:flex"
                        textClasses="text-nowrap max-lg:text-[30px] max-sm:text-h6 max-lg:text-h5 lg:text-h4 2xl:text-h3"
                        variant="secondary"
                        title={t('Buttons.faq')}
                        index={1}
                        isActive={mode === Mode.Faq}
                        onClick={() => {
                            setMode(Mode.Faq);
                            router.push(`#${SECTION_ID}`);
                        }}
                    />
                    <Button
                        className="[&>div]:flex"
                        textClasses="text-nowrap max-lg:text-[30px] max-sm:text-h6 max-lg:text-h5 lg:text-h4 2xl:text-h3"
                        variant="secondary"
                        title={t('Buttons.contactUs')}
                        index={2}
                        isActive={mode === Mode.Form}
                        onClick={() => {
                            setMode(Mode.Form);
                            router.push(`#${SECTION_ID}`);
                        }}
                    />
                </div>
                <div className="w-full max-w-[960px] 2xl:min-h-screen mr-5">
                    {mode === 'faq' ? (
                        <AccordionsBlock accordions={questions(t)} />
                    ) : (
                        <ContactForm />
                    )}
                </div>
            </div>
        </Section>
    );
}
